import { render } from "./SectionAnnouncementPage.vue?vue&type=template&id=68a5e768&scoped=true"
import script from "./SectionAnnouncementPage.vue?vue&type=script&lang=js"
export * from "./SectionAnnouncementPage.vue?vue&type=script&lang=js"

import "./SectionAnnouncementPage.vue?vue&type=style&index=0&id=68a5e768&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68a5e768"]])

export default __exports__